module.exports = __webpack_public_path__ + "img/tundra-24.419f3dfa.jpeg";